import { render, staticRenderFns } from "./UpdateColors.vue?vue&type=template&id=121994cb&scoped=true&"
import script from "./UpdateColors.vue?vue&type=script&lang=js&"
export * from "./UpdateColors.vue?vue&type=script&lang=js&"
import style0 from "./UpdateColors.vue?vue&type=style&index=0&id=121994cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121994cb",
  null
  
)

export default component.exports